///////////////////////////
/*GITNOCOMMIT*/
//////////

// Polyfills
import objectFitImages from "object-fit-images";
import objectFitVideos from "object-fit-videos";

objectFitImages();
objectFitVideos();

import "picturefill";
import lazySizes from "lazysizes";

import "details-polyfill";


import rangeSlider from "./loanCalculator/rangeslider"
import './components/decimal-seperator'
import './components/readmore'
import './components/norm-messages'
